import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import eventType from "../../../prop-types/eventType";
import { createAccount } from "../../../state/user/actions";
import CreateAccountForm from "../components/create-account-form";
import { USER } from "../../../constants";
import { Template } from "../../../commons/elements";
import "../styles/create-account.scss";
import "../../../commons/formik/styles/formik.scss";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired,
  // Map state to props
  clientId: PropTypes.number.isRequired,
  // Map dispatch to props
  createAccountAction: PropTypes.func.isRequired
};

function CreateAccountContainer(props) {
  const { types, createAccountAction, clientId } = props;

  return (
    <Template header="Create Account" tabName={USER} types={types}>
      <CreateAccountForm
        createAccount={createAccountAction}
        clientId={clientId}
      />
    </Template>
  );
}

CreateAccountContainer.propTypes = propTypes;

const mapStateToProps = (state) => ({
  clientId: state.client.client.id
});

const mapDispatchToProps = {
  createAccountAction: createAccount
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAccountContainer);
